import Api from '../api';
import {
  GROUP_DETAILS,
  GROUP_URL,
  ADD_USER_GROUP,
  DELETE_USER_GROUP,
  UPDATE_GROUP,
  DELETE_GROUP,
  ADD_GROUP,
  DOWNLOAD_GROUP_CONTACT,
  DOWNLOAD_GROUP_CONTACT_URL,
} from '../lib/constant';
import { handleAPIDispatch, handleRejectCatch } from '../lib/utils';

// GetGroup returns only metadata; legacy response embedded members too.
// Fetch both endpoints and merge so views keep seeing
// `gDetails.data.{id,name,contacts}`.
export function groupDetails(gId) {
  return (dispatch) => {
    Promise.all([
      Api.get(`${GROUP_URL}/${gId}`).then(({ data }) => data),
      fetchAllGroupContacts(gId),
    ])
      .then(([groupMeta, members]) => {
        const g = (groupMeta && groupMeta.data) || {};
        dispatch({
          type: GROUP_DETAILS,
          payload: {
            success: !!(groupMeta && groupMeta.success),
            data: {
              id: g.id,
              name: g.name,
              description: g.description,
              contacts: members,
            },
          },
        });
      })
      .catch((err) => handleRejectCatch(dispatch, err, GROUP_DETAILS));
  };
}

async function fetchAllGroupContacts(gId) {
  const url = `${GROUP_URL}/${gId}/contacts`;
  const out = [];
  let pageToken = '';
  do {
    const { data } = await Api.get(url, true, {
      page_size: 200,
      page_token: pageToken,
    });
    if (!data || !data.success) {
      const err = new Error((data && data.message) || 'ListGroupContacts failed');
      err.response = { data };
      throw err;
    }
    if (Array.isArray(data.data)) out.push(...data.data);
    pageToken = data.nextPageToken || '';
  } while (pageToken);
  return out;
}

// Legacy params: {contacts: [id, ...]}. Proto expects {contactIds}.
export function addUserGroup(params, gId) {
  const body = { contactIds: params.contactIds || params.contacts || [] };
  const request = Api.post(`${GROUP_URL}/${gId}/contacts`, body);
  return handleAPIDispatch(request, ADD_USER_GROUP);
}

// Legacy was PUT with {contacts}. Proto is POST :remove with {contactIds}.
export function deleteUserGroup(gId, params) {
  const body = { contactIds: params.contactIds || params.contacts || [] };
  const request = Api.post(`${GROUP_URL}/${gId}/contacts:remove`, body);
  return handleAPIDispatch(request, DELETE_USER_GROUP);
}

// RenameGroup: PUT /api/v1/contact-groups/{id} with {name, description}.
export function updateGroup(gId, params) {
  const request = Api.put(`${GROUP_URL}/${gId}`, params);
  return handleAPIDispatch(request, UPDATE_GROUP);
}

// CreateGroup: POST /api/v1/contact-groups with {name, description, contactIds}.
// Legacy consumer reads addGroupResponse.data.groupId for the post-create
// redirect, so alias `id` → `groupId` in the dispatched payload.
export function addGroup(params) {
  const body = {
    name: params.name,
    description: params.description || '',
    contactIds: params.contactIds || params.contacts || [],
  };
  return (dispatch) => {
    Api.post(GROUP_URL, body)
      .then(({ data }) => {
        const g = (data && data.data) || {};
        dispatch({
          type: ADD_GROUP,
          payload: {
            success: !!(data && data.success),
            data: { ...g, groupId: g.id },
          },
        });
      })
      .catch((err) => handleRejectCatch(dispatch, err, ADD_GROUP));
  };
}

export function deleteGroup(gId) {
  const request = Api.delete(`${GROUP_URL}/${gId}`);
  return handleAPIDispatch(request, DELETE_GROUP);
}

export function downloadGroupContact(gId) {
  const request = Api.get(DOWNLOAD_GROUP_CONTACT_URL.replace('gId', gId));
  return handleAPIDispatch(request, DOWNLOAD_GROUP_CONTACT);
}
